import { AnyAction } from 'redux'
import { connect, ConnectedProps } from 'react-redux'
import { produce } from 'immer'
import { RootState } from '../../store'
import { NotifyType } from '../Notify'
import { AlertProps } from './Alert'

interface AlertState {
  visible: boolean
  type: NotifyType
  message: string
}

export type AlertStateProps = ConnectedProps<typeof connector>

const initialState: AlertState = {
  visible: false,
  type: 'info',
  message: ''
}

export const actions = {
  push: 'alert/push',
  clear: 'alert/clear'
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.push:
      return produce(state, draft => {
        draft.visible = true
        draft.type = action.alert.type
        draft.message = action.alert.message
      })
    case actions.clear:
      return produce(state, draft => {
        draft.visible = false
      })
    default:
      return state
  }
}

export const mapDispatchToProps = {
  push (type: NotifyType, message: string) {
    const alert = { type, message }
    return { type: actions.push, alert }
  },
  clear () {
    return { type: actions.clear }
  }
}

function mapStateToProps (state: RootState, props?: AlertProps) {
  return produce(state.alert, draft => draft)
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
